/**
 * LA PROMESA DEL DIA EN TRES CIFRAS (PROMESA-ESTADO-T1, Ares #25944 punto "tablero").
 *
 * Criterio v0.1 (D-105 parcial, T38 #25915, vigente desde 2026-10-12 17:12): CUMPLIDO es solo lo
 * verificado ([VERIFICADO] con prueba favorable); ENTREGADO ([DONE]/[VIVO]) va aparte y no entra al
 * numerador; PENDIENTE es pendiente o prometido.
 *
 * DE DONDE SALE: indicadores_trabajo()->'3_promesa' de nexo-api PR 488 (b6b6f77, migracion
 * 2026_10_12_001): cumplidos_hoy, entregados_hoy, pendientes_hoy, ingredientes_hoy y el bloque
 * criterio { version, vigente_desde, decision }. Llega por GET /salud/indicadores, que el panel
 * ya lee entero (SaludApiClient.getIndicadores deja cada campo en `numeros`).
 *
 * "NO ANTES" (Ares #25944): con la API de antes (sin criterio ni entregados_hoy) esto devuelve
 * null y el Dashboard no pinta nada. Cuando la API sirva el 488, se enciende solo.
 * Sin DOM: lo prueba scripts/check-promesa-dashboard.mjs.
 */

const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

const entero = (v) => (v === null || v === undefined || v === '' || !Number.isFinite(Number(v)) ? null : Number(v));

/** '2026-10-12 17:12' -> '12-oct-2026 17:12'. Si no se entiende, se devuelve tal cual. */
export function fechaDelCriterio(s) {
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}:\d{2}))?/.exec(String(s || ''));
  if (!m) return String(s || '');
  return `${Number(m[3])}-${MESES[Number(m[2]) - 1]}-${m[1]}${m[4] ? ' ' + m[4] : ''}`;
}

/**
 * @param {Array} indicadores la lista de SaludApiClient.getIndicadores().data.indicadores
 * @returns {null | { cumplidos, entregados, pendientes, prometidos, criterio: string }}
 */
export function promesaDelDia(indicadores) {
  const ind = (indicadores || []).find((i) => i && i.clave === 'promesa');
  const n = ind && ind.numeros;
  const criterio = n && n.criterio;
  if (!criterio || !criterio.version || n.entregados_hoy === undefined) return null;   // la API de antes: nada
  const cumplidos = entero(n.cumplidos_hoy);
  const entregados = entero(n.entregados_hoy);
  const pendientes = entero(n.pendientes_hoy);
  if (cumplidos === null || entregados === null || pendientes === null) return null;
  return {
    cumplidos,
    entregados,
    pendientes,
    prometidos: entero(n.ingredientes_hoy),
    criterio: `criterio v${criterio.version} vigente desde ${fechaDelCriterio(criterio.vigente_desde)}`
  };
}
